// extracted by mini-css-extract-plugin
module.exports = {"content_title_zh":"Dss_content_title_zh__1p4h2","content_title_en":"Dss_content_title_en__1aemA","starmap":"Dss_starmap__SGF2N"};